import { Link, useLocation } from "react-router-dom";

const EventListStepper = () => {
  const location = useLocation();
  const tabs = [
    { to: "/MyEvents", label: "Upcoming", id: "upcoming" },
    { to: "/MyEvents/cancelled", label: "Canceled", id: "cancelled" },
    { to: "/MyEvents/visited", label: "Visited", id: "visited" },
  ];

  return (
    <nav className="event-my-events-tabs" aria-label="My events categories">
      {tabs.map((tab) => (
        <Link
          key={tab.id}
          className={`event-my-events-tab${
            location.pathname === tab.to ? " is-active" : ""
          }`}
          to={tab.to}
          aria-current={location.pathname === tab.to ? "page" : undefined}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
};

export default EventListStepper;
